/** Helpers estatus operativo cliente fiscal (activo / suspendido). */

import { canManageWorkspaceTeam } from "@/lib/auxiliaryRoleGuide";

export const OPERATIVO_ESTATUS_ACTIVO = "activo";
export const OPERATIVO_ESTATUS_SUSPENDIDO = "suspendido";

export function normalizeOperativoEstatus(value) {
  return String(value || "").trim().toLowerCase() === OPERATIVO_ESTATUS_SUSPENDIDO
    ? OPERATIVO_ESTATUS_SUSPENDIDO
    : OPERATIVO_ESTATUS_ACTIVO;
}

export function isClientOperativoSuspendido(client) {
  return normalizeOperativoEstatus(client?.operativo_estatus) === OPERATIVO_ESTATUS_SUSPENDIDO;
}

/** Misma lógica que backend ``can_manage_fiscal_client_catalog`` (titular, buyer_admin, supervisor). */
export function canManageFiscalClientCatalog(user) {
  if (!user) return false;
  if (user.has_global_client_supervision) return true;
  return canManageWorkspaceTeam(user);
}

/**
 * Alta de empresas: admins de equipo + auxiliar operativo (no consulta).
 * Alineado con backend ``can_create_fiscal_clients``.
 */
export function canCreateFiscalClients(user) {
  if (!user) return false;
  if (user.has_global_client_supervision) return true;
  const dr = user.despacho_profile?.despacho_role || user.despacho_role;
  if (dr === "consulta" || user.role === "consulta") return false;
  if (canManageFiscalClientCatalog(user)) return true;
  if (dr === "auxiliar") return true;
  if (user.role === "user" && !user.is_buyer_tenant) return true;
  return false;
}

export function canManageClientOperativoStatus(user) {
  return canManageFiscalClientCatalog(user);
}

export function formatOperativoDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("es-MX", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

export async function downloadOperativoExport({ estatus, format }) {
  const response = await import("@/lib/api").then((m) =>
    m.default.get("/clients/operativo-export", {
      params: { estatus, format },
      responseType: "blob",
    }),
  );
  const blob = response.data;
  const disposition = response.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="([^"]+)"/);
  const filename = match?.[1] || `clientes_${estatus}.${format === "pdf" ? "pdf" : "csv"}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
